import { Component } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'grid-text-editor',
  template: `
    <label *ngIf="showInput">{{ value }} </label>
    <input
      *ngIf="!showInput"
      #input
      [(ngModel)]="value"
      [ngClass]="{ 'invalid-text': isEmpty }"
      class="grid-cell-edit-layout "
      (change)="textUpdated()"
    />
  `,
  styles: [
    `
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      .invalid-text {
        border: 2px solid red !important;
      }
    `,
  ],
})
export class GridOrdDtEditorComponent {
  public params: any;
  showInput = true;
  value: any;
  isEmpty = true;

  constructor() {}

  agInit(params: any): void {
    if (params.column === 'order_date') {
      params.data.rundownOrderDate = this;
      this.value = params.data.order_date;
      if (this.value) {
        this.isEmpty = false;
      } else {
        this.isEmpty = true;
      }
    }

    this.params = params;


    if (
      this.params.data.checkedEditMode &&
      new Date(params.data.order_date) > new Date(params.data.maxorder) &&
      params.data.calc_status !== ''
    ) {
      this.showInput = false;
    } else {
      this.showInput = true;
    }
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.params = params;
    return true;
  }

  public textUpdated() {
    if (this.params.column === 'order_date') {
      if (this.value !== this.params.data.order_date) {
        this.params.data.order_date = this.value;
        this.params.data.isOrderDateUpdated = true;
      }
    } else {
      this.params.data.finalquantity = this.value;
    }
  }
}
